<template>
  <div class="issue-report">
    <button class="button button--bg mr-1 mb-2 bg-theme-1 text-white" @click="uploadHandle" v-show="uploadFlag">上传评估报告 </button>
    <div v-show="!uploadFlag">评估报告：</div>
    <div v-if="!uploadFlag && fileList.length==0">暂无</div>
    <div class="file" v-for="(item,index) in fileList" :key="index">
      <a :download="item.name" :href="item.url+'?attname='+item.name" target="_blank">
        {{item.name}}
      </a>
      <XIcon class="w-4 h-4 anticon-close" v-show="uploadFlag" @click="deleteHandle(item,index)"/>
    </div>


  </div>
</template>
<script>
  import {uploadFile} from '@/assets/js/upload.js'

  export default {
    name: 'uploadAssessmentReport',
    data() {
      return {
        fileList: [],
      }
    },
    props: {
      uploadFlag: {
        default: true,
        type: Boolean
      },
      evalReport: {
        default: function () {
          return []
        },
        type: Array
      },
    },
    watch: {
      evalReport: function () {
        this.fileList = this.evalReport || [];
      }
    },
    methods: {
      uploadHandle() {
        uploadFile(10, '*').then(res => {
          this.fileList.push(res);
          this.$emit('uploadComplete', this.fileList);
        })
      },
      deleteHandle(item, index) {
        this.fileList.splice(index, 1);
        this.$emit('uploadComplete', this.fileList);
      },
    }
  }
</script>
<style lang="scss" scoped>
  .issue-report {
    display: flex;
    align-items: center;

    span {
      font-size: 12px;
      color: #40a9ff;
    }

    .file {
      position: relative;
      margin-left: 20px;
      .anticon-close {
        display: none;
        position: absolute;
        top: -2px;
        right: -14px;
        font-size: 12px;
        cursor: pointer;
        color: #1C3FAA;
      }
    }
    .file a:hover{
      color:#1C3FAA;
    }
    .file:hover .anticon-close {
      display: block;
    }

  }
</style>


